import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useUserContext } from "../contexts/userContext";
import { useMaidStore } from "../stores/maid-store";
import { jwtDecode } from "jwt-decode";

/**
 * MaidProtectRoute - Route protection middleware for maid (แม่บ้าน) routes
 *
 * Checks:
 * 1. User is logged in
 * 2. User has branch_id in JWT token (service staff)
 */
const MaidProtectRoute = (props) => {
  const { user } = useUserContext();
  const { branchId, setBranchId, setMaidInfo } = useMaidStore();
  const navigator = useNavigate();

  useEffect(() => {
    // Check if user is logged in
    if (!user?.id) {
      navigator("/login");
      return;
    }

    // Get token and check for branch_id
    const token = localStorage.getItem("token");
    if (!token) {
      navigator("/login");
      return;
    }

    try {
      const decoded = jwtDecode(token);

      // Check if token has branch_id (service staff token)
      if (!decoded.branch_id) {
        console.warn("User does not have service staff access (no branch_id in token)");
        navigator("/login");
        return;
      }

      // Set branch info in store
      if (branchId !== decoded.branch_id) {
        setBranchId(decoded.branch_id);
        setMaidInfo({
          id: decoded.id,
          branchId: decoded.branch_id,
        });
      }
    } catch (error) {
      console.error("Error decoding token:", error);
      navigator("/login");
    }
  }, [user, branchId, navigator, setBranchId, setMaidInfo]);

  // Only render if user is authenticated and has branch_id
  if (!user?.id || !branchId) {
    return null;
  }

  return <Outlet {...props} />;
};

export default MaidProtectRoute;
